import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { Router } from '@angular/router';
import { PopoverController, RouterLinkDelegate } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { Role } from '../../enum/role';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit, OnDestroy {
    public admin = false;
    private unsubscribe: Subscription[] = [];
    public currentLanguage: string;
    constructor(private authenticationService: AuthenticationService, public router: Router, private translateService: TranslateService,
        private popoverController: PopoverController, private cookieService: CookieService) { }

    ngOnInit() {
        if (this.cookieService.get("language") === 'en') {
            this.currentLanguage = 'Français';
        }
        else {
            this.currentLanguage = 'English';
        }

        if (this.authenticationService.currentUserValue.role === Role.Admin)
            this.admin = true;
    }

    public goTo(path) {
        this.popoverController.dismiss();
        this.router.navigate([path])
    }

    logOut() {
        this.popoverController.dismiss();
        this.authenticationService.logout();
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(s => s.unsubscribe());
    }


    switchLang() {
        if (this.translateService.currentLang === 'en') {
            this.currentLanguage = 'English';
            this.translateService.use('fr');
            this.translateService.currentLang = 'fr';
        }
        else if (this.translateService.currentLang === 'fr') {
            this.currentLanguage = 'Français';
            this.translateService.use('en');
            this.translateService.currentLang = 'en';
        }
        this.cookieService.set("language", this.translateService.currentLang);
        this.popoverController.dismiss();
    }

}
